import { Component } from "@angular/core";
import { FieldArrayType } from "@ngx-formly/core";

@Component({
    selector: "formly-repeat-section-v2",
    template: `
        <div class="flex flex-col gap-4 items-center">
            <div
                *ngFor="let field of field.fieldGroup; let i = index"
                class="w-full flex flex-row items-start gap-4"
                [ngClass]="to.className"
            >
                <formly-field class="w-full" [field]="field"></formly-field>

                <button mat-icon-button (click)="remove(i)">
                    <mat-icon [svgIcon]="'trash'"></mat-icon>
                </button>
            </div>
            <div *ngIf="shouldShowError" class="text-red-500 text-sm mt-1">
                <formly-validation-message [field]="field"></formly-validation-message>
            </div>
            <v2-button-wrapper color="accent" [text]="to.addText" variant="flat" (click)="add()"></v2-button-wrapper>
        </div>
    `,
})
export class RepeatTypeComponentV2 extends FieldArrayType {
    get shouldShowError(): boolean {
        const control = this.formControl;
        return control.invalid && (control.touched || control.dirty);
    }

    remove(i: number) {
        super.remove(i);
        this.formControl.markAsTouched();
        this.formControl.markAsDirty();
        this.formControl.updateValueAndValidity();
    }
}
